import { IVDPfooter } from "../../apis/useGetConfig";
import { Nullable } from "../../common/types/types";

export interface ILocation {
	id: string;
	name: string;
	outletid?: string;
	description?: string;
	cluster?: string;
}

export enum APP_MODE {
	VIEW = "VIEW",
	NORMAL = "NORMAL",
}
export interface IStall {
	mode: IStallMode;
	name?: string;
	image_url?: string;
}

export enum IStallMode {
	SOK = "sok",
	HIKINIKU = "hikiniku",
}

export interface IConfigState {
	user: {
		session_id: Nullable<number | string>;
		role: CONFIG_ROLES;
	};
	theme: "light";
	location: ILocation;
	isLoading: boolean;
	errorMessage: Nullable<string>;
	count: number;
	config: IAppConfig;
	appMode: APP_MODE;
	stallMode: Nullable<IStallMode>;
	inited: boolean;
	devMode: boolean;
	adminAccessGranted: boolean;
	maintenanceAccessGranted: boolean;
}

export enum CONFIG_ROLES {
	GUEST = "guest",
	MEMBER = "member",
}

export interface IStallConfig {
	name: string;
	image_url: string;
	mode: Nullable<IStallMode>;
	address?: Nullable<string[]>;
}

export interface IGrillOption {
	label: string;
	id: string;
}

export interface IAppConfig {
	// For disable set item's alacarte_bmi
	hidden_alacarte_bmi?: number[];
	stall: IStallConfig;
	VDPfooter: Nullable<IVDPfooter>;
	enable_sok: boolean;
	takeaway_fee: number;
	bcrs_deposit_rate: number;
	show_initial_takeaway_selection?: boolean;
	grillNumber?: IGrillOption[] | null;
	enableDevTools?: boolean;
}
